(async () => {
  const locationRequest = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
  const locationData = await locationRequest.json();
  const country = locationData.detected_values.country.handle;

  if (country === "US") {
    document.querySelectorAll('footer a[href*="/pages/returns-portal"]').forEach((link) => {
      link.href = "https://gooseberryintimates.happyreturns.com/";
    });
  }
})();
